import React from "react";

const UtilityFuncs = {
	operationHour: (location, translations) => {
		const operationHR = [];

		if (location?.Hours) {
			operationHR.push(`${translations.hoursOfOperation}: ${location?.Hours}`);
		}

		if (location?.BreakfastHours) {
			operationHR.push(`${translations.breakfastHours}: ${location?.BreakfastHours}`);
		}

		if (location?.LunchHours) {
			operationHR.push(`${translations.lunchHours}: ${location?.LunchHours}`);
		}

		if (location?.DinnerHours) {
			operationHR.push(`${translations.dinnerHours}: ${location?.DinnerHours}`);
		}

		return operationHR;
	},
	formatFeatures: data =>
		data
			?.map(x => {
				const feature = [];

				if (x.Quantity) {
					feature.push(`${x.Quantity} `);
				}

				feature.push(x.FeatureTitle);

				if (x.AdditionalComments) {
					feature.push(
						<>
							<br />
							<span
								// eslint-disable-next-line react/no-danger
								dangerouslySetInnerHTML={{
									__html: x.AdditionalComments,
								}}
							/>
						</>
					);
				}

				return feature;
			})
			?.filter(x => x),
};

export { UtilityFuncs };
